<template>
  <li class="relative max-w-4xl ml-4 pl-6 pb-6" :class="{'border-blue-900': !finalStep, 'border-white': finalStep}">
    <div class="absolute -ml-4 top-0 left-0 block mb-2 align-middle border border-solid font-sans font-semibold leading-snug rounded-full text-center select-none"
      :class="{'bg-blue-900 border-blue-900 text-white': completed, 'bg-white border-blue-900 text-blue-900': !completed}"
      style="line-height:40px;height:40px;width:40px;">
      
      <doe-icon v-if="completed" icon="circleCheck" class="mt-3" />
      <span v-else>
        {{ step }}
      </span>
    </div>

    <slot />
  </li>
</template>

<script>
import DoeIcon from "@/components/icon/Icon";

export default {
  name: "DoeStepperBlock",
  props: {
    step: {
      type: Number,
      required: true
    },
    finalStep: {
      type: Boolean,
      required: false,
      default: false
    },
    completed: {
      type: Boolean,
      required: true
    }
  },
  components: {
    DoeIcon
  }
};
</script>

<style lang="scss" scoped></style>
